/**
 * 浅色系环图
 * @param unit 单位
 * @param dataArr [{name:'',value:0}]数据合集
 */
import { dealBigNum, amountFun } from "@/assets/js/utils";
export function setOption(paramObj) {
  let tol = 0;
  tol = amountFun(paramObj.dataArr);
  let option = {
    title: {
      text: "总数",
      x: "center",
      y: "40%",
      textStyle: {
        color: "#999",
        fontSize: 12,
        align: "center",
      },
      subtext: tol == 0 ? "0" : tol,
      subtextStyle: {
        fontSize: 14,
        color: "#999",
      },
    },
    tooltip: {
      trigger: "item",
      formatter: function (param) {
        return `${param.name}:${dealBigNum(param.value)}${paramObj.unit} ${
          param.percent == undefined || param.percent < 0.01
            ? 0.01
            : param.percent
        }%`;
      },
    },
    legend: {
      type: "scroll",
      bottom: "bottom",
      itemHeight: 5,
      itemWidth: 5,
    },
    color: EchartsLightColor,
    series: [
      {
        type: "pie",
        radius: ["40%", "60%"],
        data: paramObj.dataArr,
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: "rgba(0, 0, 0, 0.5)",
          },
        },
        label: {
          formatter: (params) => {
            return (
              params.name +
              "\n" +
              (params.percent == undefined || params.percent < 0.01
                ? 0.01
                : params.percent) +
              "% {value|" +
              dealBigNum(params.value) +
              "}"
            );
          },
          rich: {
            icon: {
              fontSize: 12,
              color: "inherit",
            },
            name: {
              fontSize: 12,
              padding: [0, 0, 0, 10],
              color: "#000",
            },
            value: {
              fontSize: 12,
              fontWeight: "bolder",
              padding: [0, 0, 0, 0],
              color: "inherit",
            },
          },
        },
      },
    ],
  };

  return option;
}
